import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 * Directive to automatically add data-cy attributes to formly field inputs
 * Usage: Add [formlyDataCy]="field" to any input element in a formly component
 */
@Directive({
  selector: '[formlyDataCy]',
  standalone: true,
})
export class FormlyDataCyDirective implements OnInit {
  @Input() formlyDataCy?: FormlyFieldConfig;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    if (this.formlyDataCy?.props?.attributes?.['data-cy']) {
      this.renderer.setAttribute(
        this.el.nativeElement,
        'data-cy',
        this.formlyDataCy.props.attributes['data-cy'] as string
      );
    }
  }
}
